export const drawer = {
  drawer_background_color: '#2d2d2d',
};

export default drawer;
